/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booster_Pack_MegaInputs */

const en_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mega Pack`)
};

const ar_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزمة ضخمة`)
};

const de_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mega-Paket`)
};

const es_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mega pack`)
};

const fr_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méga pack`)
};

const it_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetto mega`)
};

const ja_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メガパック`)
};

const ko_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메가 패키지`)
};

const pt_br_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacote mega`)
};

const ru_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мега пакет`)
};

const th_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คเมกะ`)
};

const tr_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mega paket`)
};

const zh_cn_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大礼包`)
};

const zh_tw_booster_pack_mega = /** @type {(inputs: Booster_Pack_MegaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大禮包`)
};

/**
* | output |
* | --- |
* | "Mega Pack" |
*
* @param {Booster_Pack_MegaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const booster_pack_mega = /** @type {((inputs?: Booster_Pack_MegaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booster_Pack_MegaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booster_pack_mega(inputs)
	if (locale === "ar") return ar_booster_pack_mega(inputs)
	if (locale === "de") return de_booster_pack_mega(inputs)
	if (locale === "es") return es_booster_pack_mega(inputs)
	if (locale === "fr") return fr_booster_pack_mega(inputs)
	if (locale === "it") return it_booster_pack_mega(inputs)
	if (locale === "ja") return ja_booster_pack_mega(inputs)
	if (locale === "ko") return ko_booster_pack_mega(inputs)
	if (locale === "pt_br") return pt_br_booster_pack_mega(inputs)
	if (locale === "ru") return ru_booster_pack_mega(inputs)
	if (locale === "th") return th_booster_pack_mega(inputs)
	if (locale === "tr") return tr_booster_pack_mega(inputs)
	if (locale === "zh_cn") return zh_cn_booster_pack_mega(inputs)
	return zh_tw_booster_pack_mega(inputs)
});